module.exports = __webpack_public_path__ + "img/icon-chongyun.4345d139.webp";